export { default } from './GraphLegend'
